import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=5971aa95&scoped=true&"
import script from "./RegisterPage.vue?vue&type=script&lang=js&"
export * from "./RegisterPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/auth.css?vue&type=style&index=0&id=5971aa95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971aa95",
  null
  
)

export default component.exports